import angular from 'angular';
import ROLES from 'Helpers/permissions';

(function () {
    'use strict';

    angular

        .module('app')
        .factory('httpRequestInterceptor', [
            'SessionService',
            function (SessionService) {
                return {
                    request: function (config) {
                        // Get the token from session service
                        var token = SessionService.getToken();

                        // Attach an x-access-token header to the request
                        // With the token from sesison service as value
                        config.headers['x-access-token'] = token;

                        return config;
                    }
                };
            }
        ])
        .config([
            '$httpProvider',
            function ($httpProvider) {
                // Add our created http interceptor
                $httpProvider.interceptors.push('httpRequestInterceptor');
            }
        ])
        .config([
            'toastrConfig',
            function (toastrConfig) {
                // Configure the toastr container
                angular.extend(toastrConfig, {
                    // autoDismiss: false,
                    // containerId: 'toast-container',
                    maxOpened: 5,
                    // newestOnTop: true,
                    positionClass: 'toast-top-center'
                    // preventDuplicates: false,
                    // preventOpenDuplicates: false,
                    // target: 'body'
                });

                // Configure the toastr itself
                angular.extend(toastrConfig, {
                    // allowHtml: false,
                    // closeButton: false,
                    // closeHtml: '<button>&times;</button>',
                    extendedTimeOut: 1000,
                    // iconClasses: {
                    //     error: 'toast-error',
                    //     info: 'toast-info',
                    //     success: 'toast-success',
                    //     warning: 'toast-warning'
                    // },
                    // messageClass: 'toast-message',
                    // onHidden: null,
                    // onShown: null,
                    // onTap: null,
                    // progressBar: false,
                    // tapToDismiss: true,
                    // templates: {
                    //     toast: 'directives/toast/toast.html',
                    //     progressbar: 'directives/progressbar/progressbar.html'
                    // },
                    timeOut: 4000
                    // titleClass: 'toast-title',
                    // toastClass: 'toast'
                });
            }
        ])
        .config(router)
        .run([
            '$transitions',
            function ($transitions) {
                // checks if not authenticated when going to app.** routes
                $transitions.onBefore({ to: 'app.**' }, function (trans) {
                    var SessionService = trans.injector().get('SessionService');

                    if (!SessionService.getUser()) {
                        // redirects to login
                        return trans.router.stateService.target('login');
                    }
                });

                // checks if already authenticated when going to login route
                $transitions.onBefore({ to: 'login' }, function (trans) {
                    var SessionService = trans.injector().get('SessionService');

                    // redirects to dashboard (?)
                    if (SessionService.getUser()) {
                        return trans.router.stateService.target(
                            'app.dashboard'
                        );
                    }
                });
            }
        ])
        .run([
            '$cookies',
            'QueryService',
            function ($cookies, QueryService,) {
                if ($cookies.getObject('user') != null) {
                    var user = $cookies.getObject('user');
                    var permissions = ROLES[user.role];
                }
            }
        ]);

    router.$inject = ['$stateProvider', '$urlRouterProvider'];

    function router($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/');
        $stateProvider
            .state('app', {
                abstract: true,
                url: '/',
                views: {
                    navbar: {
                        component: 'navbar'
                    },
                    sidebar: {
                        component: 'sidebar'
                    },
                    content: {
                        component: 'content'
                    }
                }
            })
            .state('home-page', {
                url: '/home-page-old?id',
                views: {
                    content: {
                        component: 'homepage'
                    },
                    header: {
                        component: 'sspheader'
                    },
                    footer: {
                        component: 'sspfooter'
                    }
                }
            })
            .state('demo', {
                url: '/demo?coupon_code',
                views: {
                    content: {
                        component: 'demo'
                    }
                }
            })
            .state('apply', {
                url: '/home?page',
                views: {
                    content: {
                        component: 'apply'
                    }   
                }
            })
            .state('apply2', {
                url: '/apply3',
                views: {
                    content: {
                        component: 'apply2'
                    }
                }
            })
            .state('apply3', {
                url: '/?state',
                views: {
                    content: {
                        component: 'apply3'
                    }
                }
            })
            .state('login2', {
                url: '/login?app&specs&popup',
                views: {
                    content: {
                        component: 'login'
                    }
                }
            })
            .state('application-details', {
                url: '/application-details?app',
                views: {
                    content: {
                        component: 'applicationDetails3'
                    }
                }
            })
            .state('download-app', {
                url: '/download_app',
                views: {
                    content: {
                        component: 'downloadApp'
                    }
                }
            })
            .state('demo-teacher', {
                url: '/demo-teacher?coupon_code',
                views: {
                    content: {
                        component: 'demoteacher'
                    }
                }
            })
            .state('payment2', {
                url: '/payment_2co?id',
                views: {
                    content: {
                        component: 'payment2'
                    }
                }
            })
            .state('tctp', {
                url: '/payment?id',
                views: {
                    content: {
                        component: 'tctp'
                    }
                }
            })
            .state('record', {
                url: '/record',
                views: {
                    content: {
                        component: 'record'
                    }
                }
            })
            .state('ssp', {
                url: '/home-page?id',
                views: {
                    content: {
                        component: 'ssp'
                    }
                }
            })
            .state('complaint', {
                url: '/complaint?id&mode',
                views: {
                    content: {
                        component: 'complaint'
                    },
                    header: {
                        component: 'sspheader'
                    },
                    footer: {
                        component: 'sspfooter'
                    }
                }
            })
            .state('contact', {
                url: '/contact',
                views: {
                    content: {
                        component: 'contact'
                    },
                    header: {
                        component: 'sspheader'
                    },
                    footer: {
                        component: 'sspfooter'
                    }
                }
            })
            .state('rating', {
                url: '/rating-old?id',
                views: {
                    content: {
                        component: 'rating'
                    },
                    header: {
                        component: 'sspheader'
                    },
                    footer: {
                        component: 'sspfooter'
                    }
                }
            })
            .state('feedback', {
                url: '/feedback?id',
                views: {
                    content: {
                        component: 'feedback'
                    },
                }
            })
            .state('rating-page', {
                url: '/rating-page?id',
                views: {
                    content: {
                        component: 'ratingpage'
                    }
                }
            })
            .state('rating-page2', {
                url: '/rating?id',
                views: {
                    content: {
                        component: 'ratingpage2'
                    }
                }
            })
            .state('changes', {
                url: '/changes?id',
                views: {
                    content: {
                        component: 'changes'
                    },
                    header: {
                        component: 'sspheader'
                    },
                    footer: {
                        component: 'sspfooter'
                    }
                }
            })
            .state('pricing', {
                url: '/pricing?id',
                views: {
                    content: {
                        component: 'pricing'
                    },
                    header: {
                        component: 'sspheader'
                    },
                    footer: {
                        component: 'sspfooter'
                    }
                }
            })
            .state('pricing2', {
                url: '/pricing2?id',
                views: {
                    content: {
                        component: 'pricing2'
                    }
                }
            })
            .state('doll-house', {
                url: '/dayoung-x-share-lab-demo',
                views: {
                    content: {
                        component: 'dollhouse'
                    }
                }
            })
            .state('doll-house-select', {
                url: '/doll-house-select?id',
                views: {
                    content: {
                        component: 'dollhouseselect'
                    }
                }
            })
            .state('bookings', {
                url: '/bookings?id',
                views: {
                    content: {
                        component: 'bookings'
                    }
                }
            })
            .state('scheduler', {
                url: '/scheduler?id&module_no',
                views: {
                    content: {
                        component: 'scheduler'
                    }
                }
            })
            .state('watchgo', {
                url: '/watchgo',
                views: {
                    content: {
                        component: 'watchgo'
                    }
                }
            })
    }
})();



// WEBPACK FOOTER //
// ./src/app/app.config.js